import {
  MOUNT,
  UNMOUNT,
  UPDATE_PRODUCT_DETAILS,
  CLEAR_PRODUCT_DETAILS,
  FETCH_PRODUCT_DETAILS,
  FETCH_PRODUCT_DETAILS_START,
  FETCH_PRODUCT_DETAILS_SUCCESS,
  FETCH_PRODUCT_DETAILS_ERROR,
} from './constants'
import {
  buildAsyncAction,
} from 'containers/Async/actions'

const mount = (id) => ({ type: MOUNT, id })
const unmount = () => ({ type: UNMOUNT })
const updateProductDetails = (id) => ({ type: UPDATE_PRODUCT_DETAILS , id })
const clearProductDetails = () => ({ type: CLEAR_PRODUCT_DETAILS })
const fetchProductDetails = () => ({ type: FETCH_PRODUCT_DETAILS })
const fetchProductDetailsStart = () => ({ type: FETCH_PRODUCT_DETAILS_START })
const fetchProductDetailsSuccess = () => ({ type: FETCH_PRODUCT_DETAILS_SUCCESS })
const fetchProductDetailsError = (error) => ({ type: FETCH_PRODUCT_DETAILS_ERROR, error })
const startFetchProductDetails = buildAsyncAction(
  FETCH_PRODUCT_DETAILS,
  FETCH_PRODUCT_DETAILS_START,
  [FETCH_PRODUCT_DETAILS_SUCCESS, FETCH_PRODUCT_DETAILS_ERROR]
)

export {
  mount,
  unmount,
  updateProductDetails,
  clearProductDetails,
  fetchProductDetails,
  fetchProductDetailsStart,
  fetchProductDetailsSuccess,
  fetchProductDetailsError,
  startFetchProductDetails,
}
